export enum LocalityType {
  Unknown = 0,
  City = 1,
  CityCountry = 2,
  PostTown = 3,
  Suburb = 4,
  SuburbCity = 5,
  VillageTownshipCity = 6,
}
